import { useEffect, useRef } from 'react';
import { useSignOut } from 'react-auth-kit';
import axios from 'axios';

// Setup interceptor immediately when module loads (before component mounts)
let interceptorSetup = false;
let signOutRef = null;
let isRedirecting = false;

const setupInterceptor = () => {
    if (interceptorSetup) return;

    console.log('AuthWrapper: Setting up global axios interceptor');

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            console.log('AuthWrapper: Error intercepted', error);
            console.log('AuthWrapper: error.response?.status', error.response?.status);

            const status = error.response?.status;

            if (status === 401 && !isRedirecting) {
                console.warn('Token expired or unauthorized. Redirecting to login...');
                isRedirecting = true;

                if (signOutRef) {
                    try {
                        signOutRef();
                    } catch (e) {
                        console.error('Error during signOut:', e);
                    }
                }

                window.location.href = '/login';
            }
            return Promise.reject(error);
        }
    );

    interceptorSetup = true;
};

// Setup immediately
setupInterceptor();

const AuthWrapper = ({ children }) => {
    const signOut = useSignOut();

    useEffect(() => {
        // Store signOut ref for the interceptor to use
        signOutRef = signOut;
        console.log('AuthWrapper: Component mounted, signOut ref set');
    }, [signOut]);

    return children;
};

export default AuthWrapper;
